import HeaderContainers from '../HeaderContainers/HeaderContainers';
import InputPadrao from '../InputPadrao/InputPadrao';
import BotaoPadrao from '../BotaoPadrao/BotaoPadrao';
import InputSelectPadrao from '../InputSelectPadrao/InputSelectPadrao';
import './FormEditarDepartamento.css'
import { MdBadge } from "react-icons/md";
import { useContext, useEffect, useState } from 'react';
import { RiErrorWarningFill } from "react-icons/ri";
import { getSituacaoCadastro } from '../../services/situacaoCadastroService';
import { SiGlassdoor } from "react-icons/si";
import { EditarDepartamentoContext } from '../../context/EditarDepartamentoContext';
import { getDepartamentoById } from '../../services/departamentoService';
import NotifyUtils from '../../utils/NotifyUtils';
import { useTranslation } from 'react-i18next';

function FormEditarDepartamento({ idDepartamento }) {

    const { t } = useTranslation();
    const { departamentoData, setDepartamentoData, handleChange, handleCancelling, handleSubmit } = useContext(EditarDepartamentoContext);

    useEffect(() => {
        if(departamentoData === null || departamentoData === undefined || departamentoData.idDepartamento === 0) {
            getDepartamentoById(idDepartamento).then((departamento) => {
                setDepartamentoData(departamento);
            }).catch((error) => {
                console.error(error);
            });
        }
    }, []);

    const textoCarregando = t("texto-carregando");
    const textoConfirmar = t("botao-confirmar");
    const [botaoDesabilitado, setBotaoDesabilitado] = useState(false);
    const [mensagemBotaoConfirmar, setMensagemBotaoConfirmar] = useState(textoConfirmar);

    const [ nomeDepartamentoValido, setNomeDepartamentoValido ] = useState(true);
    const [ siglaValida, setSiglaValida ] = useState(true);
    const [ situacaoCadastroValida, setSituacaoCadastroValida ] = useState(true);

    const [situacaoCadastro, setSituacaoCadastro] = useState(null);
    useEffect(() => {
        getSituacaoCadastro().then((situacaoCadastro) => {
            setSituacaoCadastro(situacaoCadastro);
        }).catch((error) => {
            console.error(error);
        });
    }, []);
    
    const handleCancelar = () => {
        handleCancelling();
    }

    if (departamentoData === null || departamentoData.idDepartamento === undefined || departamentoData.idDepartamento === 0) {
        return <div>Loading...</div>;
    }

    let situacoesCadastro = [];
    if (situacaoCadastro !== null) {
        situacoesCadastro = situacaoCadastro;
    } else {
        return <div>Loading...</div>;
    }

    const clickBotaoConfirmar = async (e) => {
        // Assim que confirmar, desabilita o botão e muda o texto para "carregando..."
        e.preventDefault();
        setBotaoDesabilitado(true);
        setMensagemBotaoConfirmar(textoCarregando);

        // Faz o envio de informações para o back caso esteja tudo certo com os campos, se não tiver, retorna os campos inválidos
        const retornoRequest = await handleSubmit();
        const erroCustom = retornoRequest.success === undefined;

        if(retornoRequest === null) {
            NotifyUtils.info("texto-editando");
            return;
        }

        if(!retornoRequest.success && !erroCustom) {
            NotifyUtils.erro(retornoRequest.message);
        } else if(retornoRequest.success) {
            NotifyUtils.sucesso(retornoRequest.message);
            NotifyUtils.sucesso(t("texto-redirecionando"));

            setNomeDepartamentoValido(true);
            setSiglaValida(true);
            setSituacaoCadastroValida(true);

            setTimeout(() => {
                handleCancelling();
                setBotaoDesabilitado(false);
                setMensagemBotaoConfirmar(textoConfirmar);
            }, 3500);
            return;
        } else if(erroCustom) {
            NotifyUtils.erro(retornoRequest.message);

            // Atualiza status dos campos inválisdos
            const camposInvalidos = retornoRequest.camposInvalidos;

            setNomeDepartamentoValido(camposInvalidos.nomeValido);
            setSiglaValida(camposInvalidos.siglaValida);
            setSituacaoCadastroValida(camposInvalidos.situacaoValida);
        }

        setBotaoDesabilitado(false);
        setMensagemBotaoConfirmar(textoConfirmar);
    }

    return (
        <div className="container-cadastrar-departamento">
            <div className="container-geral-cadastro-departamento">
                <HeaderContainers texto={t("editar-departamento")} />

                <div className="formulario-cadastrar-departamento">
                    <form>
                        <div className="inputs-principais-cadastro-departamento">
                            <InputPadrao
                                onChange={handleChange}
                                titulo={t("nome-departamento")}
                                obrigatorio={true}
                                name={"nome-departamento"}
                                className={"nome-departamento-cad"}
                                placeholder={t("place-holder-departamento")}
                                inputPara={"nomeDepartamento"}
                                icone={<MdBadge />}
                                comErro={!nomeDepartamentoValido}
                                valorInicial={departamentoData.nomeDepartamento}
                            />

                            <InputPadrao
                                onChange={handleChange}
                                className={"sigla-departamento-cad"}
                                titulo={t("sigla")}
                                obrigatorio={true}
                                name={"sigla-departamento"}
                                placeholder={t("place-holder-siglas-departamento")}
                                inputPara={"sigla"}
                                icone={<SiGlassdoor />}
                                comErro={!siglaValida}
                                valorInicial={departamentoData.sigla}
                            />

                            <InputSelectPadrao
                                onChange={handleChange}
                                className={"situacao-cadastro-departamento-cad"}
                                titulo={t("situacao-cadastro")}
                                obrigatorio={true}
                                icone={<RiErrorWarningFill />}
                                name={"situacao-cadastro"}
                                placeholder={t("place-holder-sitCad")}
                                inputPara={"situacaoCadastro"}
                                options={situacoesCadastro}
                                comErro={!situacaoCadastroValida}
                                valorInicial={t("situacao-" + departamentoData.situacaoCadastro.idSituacaoCadastro)}                              
                            />
                        </div>

                        <div className="botoes-cadastro-departamento">
                            <BotaoPadrao
                                 texto={t("botao-voltar")}
                                 cancelar={true}
                                 acaoDeClicar={handleCancelar}
                            />
                            <BotaoPadrao
                                texto={botaoDesabilitado ? t("texto-carregando") : t("confirmar-edicao")}
                                confirmar={true}
                                acaoDeClicar={clickBotaoConfirmar}
                                disabled={botaoDesabilitado}
                            />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default FormEditarDepartamento;